<template>
  <div class="home">
    <Languages class="languages gui__element gui__element--top-right" />
    <ul>
      <li v-for="tour in tours" :key="tour.id">
        <a :href="`/${$locale}/virtual-tour/${tour.slug}`">{{ tour.title }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import virtualTourApi from "@/api";
import Languages from "@/components/Languages";

export default {
  name: "Home",
  props: ["page"],
  components: {
    Languages,
  },
  data() {
    return {
      tours: [],
    };
  },
  mounted() {
    virtualTourApi.getAllTours().then((res) => (this.tours = res.data));
  },
};
</script>
<style lang="scss">
.home {
  .languages a {
    color: $color-text;
  }
}
</style>
